import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p479221538450710528',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
